module.exports = __webpack_public_path__ + "img/4f_r_sanko_2@2x.9fd836a1.png";